import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  productDetails: {
    id: 'product.tabs.details',
    description: 'Product details tab label',
    defaultMessage: 'Product Details',
  },
  priceDetails: {
    id: 'product.tabs.price',
    description: 'Product Form price detail tab',
    defaultMessage: 'Price Details',
  },
  physicalProperties: {
    id: 'product.tabs.physical',
    description: 'Product Form Physical Properties Tab Label',
    defaultMessage: 'Physical Properties',
  },
  temperature: {
    id: 'product.tabs.temperature',
    description: 'Product Form Temperature Tab Label',
    defaultMessage: 'Temperature',
  },
  currencies: {
    id: 'product.price.currencies',
    description: 'Currencies section title',
    defaultMessage: 'Currencies',
  },
  priceHistory: {
    id: 'product.price.priceHistory',
    description: 'Price History section title',
    defaultMessage: 'Price History',
  },
  addCurrency: {
    id: 'product.price.addCurrency',
    description: 'Add Currency button text',
    defaultMessage: 'ADD CURRENCY',
  },
  addPrice: {
    id: 'product.price.addPrice',
    description: 'Add Price button text',
    defaultMessage: 'Add price',
  },
  revertPrice: {
    id: 'product.price.reverPrice',
    description: 'Revert Price button text',
    defaultMessage: 'Revert',
  },
  currency: {
    id: 'product.price.currency',
    description: 'Currency column header',
    defaultMessage: 'Currency',
  },
  activePrice: {
    id: 'product.price.activePrice',
    description: 'Active Price column header',
    defaultMessage: 'Price',
  },
  validFrom: {
    id: 'product.price.validFrom',
    description: 'Valid From column header',
    defaultMessage: 'Valid From',
  },
  validTo: {
    id: 'product.price.validTo',
    description: 'Valid To column header',
    defaultMessage: 'Valid To',
  },
  daysInUse: {
    id: 'product.price.daysInUse',
    description: 'Days In Use column header',
    defaultMessage: 'Days In Use',
  },
  description: {
    id: 'product.price.description',
    description: 'Description column header',
    defaultMessage: 'Description',
  },
  delete: {
    id: 'product.price.delete',
    description: 'Delete tooltip text',
    defaultMessage: 'Delete',
  },
  viewDocuments: {
    id: 'product.price.viewDocuments',
    description: 'View Documents tooltip text',
    defaultMessage: 'View Documents',
  },
  updatedAt: {
    id: 'product.price.updatedAt',
    description: 'Updated At label',
    defaultMessage: 'Updated At:',
  },
  updatedBy: {
    id: 'product.price.updatedBy',
    description: 'Updated By label',
    defaultMessage: 'Updated By:',
  },
  pleaseEnter: {
    id: 'common.pleaseEnter',
    description: 'Please enter placeholder',
    defaultMessage: 'Please enter',
  },
  viewPrice: {
    id: 'product.price.viewPrice',
    description: 'View Price dialog title',
    defaultMessage: 'View Price',
  },
  editPrice: {
    id: 'product.price.editPrice',
    description: 'Edit Price dialog title',
    defaultMessage: 'Edit Price',
  },
  addPriceTitle: {
    id: 'product.price.addPriceTitle',
    description: 'Add Price dialog title',
    defaultMessage: 'Add Price',
  },
  close: {
    id: 'common.close',
    description: 'Close button text',
    defaultMessage: 'Close',
  },
  cancel: {
    id: 'common.cancel',
    description: 'Cancel button text',
    defaultMessage: 'Cancel',
  },
  update: {
    id: 'common.update',
    description: 'Update button text',
    defaultMessage: 'Update',
  },
  add: {
    id: 'common.add',
    description: 'Add button text',
    defaultMessage: 'Add',
  },
  editMode: {
    id: 'product.editMode',
    description: 'Edit mode label',
    defaultMessage: 'Edit Mode',
  },
  weight: {
    id: 'product.physical.weight',
    description: 'Weight section title',
    defaultMessage: 'Weight',
  },
  netWeight: {
    id: 'product.physical.netWeight',
    description: 'Net Weight label',
    defaultMessage: 'Net Weight',
  },
  grossWeight: {
    id: 'product.physical.grossWeight',
    description: 'Gross Weight label',
    defaultMessage: 'Gross Weight',
  },
  dimensions: {
    id: 'product.physical.dimensions',
    description: 'Dimensions section title',
    defaultMessage: 'Dimensions',
  },
  length: {
    id: 'product.physical.length',
    description: 'Length label',
    defaultMessage: 'Length',
  },
  width: {
    id: 'product.physical.width',
    description: 'Width label',
    defaultMessage: 'Width',
  },
  height: {
    id: 'product.physical.height',
    description: 'Height label',
    defaultMessage: 'Height',
  },
  diameter: {
    id: 'product.physical.diameter',
    description: 'Diameter label',
    defaultMessage: 'Diameter',
  },
  volume: {
    id: 'product.physical.volume',
    description: 'Volume label',
    defaultMessage: 'Volume',
  },
  other: {
    id: 'product.physical.other',
    description: 'Other section title',
    defaultMessage: 'Other',
  },
  maxLoadingHeight: {
    id: 'product.physical.maxLoadingHeight',
    description: 'Max Loading Height label',
    defaultMessage: 'Max Loading Height',
  },
  uom: {
    id: 'common.uom',
    description: 'Unit of Measure label',
    defaultMessage: 'Units',
  },
  viewDocument: {
    id: 'product.document.viewDocument',
    description: 'View Document modal title',
    defaultMessage: 'VIEW DOCUMENT',
  },
  price: {
    id: 'product.document.price',
    description: 'Price document type',
    defaultMessage: 'PRICE',
  },
  closeCaps: {
    id: 'common.closeCaps',
    description: 'Close button text in uppercase',
    defaultMessage: 'CLOSE',
  },
  viewCurrency: {
    id: 'product.currency.viewCurrency',
    description: 'View Currency dialog title',
    defaultMessage: 'View Currency',
  },
  editCurrency: {
    id: 'product.currency.editCurrency',
    description: 'Edit Currency dialog title',
    defaultMessage: 'Edit Currency',
  },
  addCurrencyTitle: {
    id: 'product.currency.addCurrencyTitle',
    description: 'Add Currency dialog title',
    defaultMessage: 'Add Currency',
  },
  temperatureRange: {
    id: 'product.temperature.temperatureRange',
    description: 'Temperature Range label',
    defaultMessage: 'Range',
  },
  lowerWarning: {
    id: 'product.temperature.lowerWarning',
    description: 'Lower Warning label',
    defaultMessage: 'Lower Warning',
  },
  upperWarning: {
    id: 'product.temperature.upperWarning',
    description: 'Upper Warning label',
    defaultMessage: 'Upper Warning',
  },
  lowerCritical: {
    id: 'product.temperature.lowerCritical',
    description: 'Lower Critical label',
    defaultMessage: 'Lower Critical',
  },
  upperCritical: {
    id: 'product.temperature.upperCritical',
    description: 'Upper Critical label',
    defaultMessage: 'Upper Critical',
  },
  pleaseSelect: {
    id: 'common.pleaseSelect',
    description: 'Please select placeholder',
    defaultMessage: 'Please select',
  },
  temperatureSetPoint: {
    id: 'product.temperature.temperatureSetPoint',
    description: 'Temperature Set Point label',
    defaultMessage: 'Set Point',
  },
  rectangle: {
    id: 'product.physicalProperties.rectangle',
    description: 'Rectangle label for temperature settings',
    defaultMessage: 'Rectangle',
  },
  cylindrical: {
    id: 'product.physicalProperties.cylindrical',
    description: 'cylindrical label for temperature settings',
    defaultMessage: 'Cylindrical',
  },
  pleaseSelectCurrency: {
    id: 'product.price.pleaseSelectCurrency',
    description: 'Please select currency placeholder',
    defaultMessage: 'Please select a currency',
  },
  netWeightRequired: {
    id: 'product.validation.netWeightRequired',
    description: 'Net Weight required validation message',
    defaultMessage: 'Net Weight is required',
  },
  grossWeightRequired: {
    id: 'product.validation.grossWeightRequired',
    description: 'Gross Weight required validation message',
    defaultMessage: 'Gross Weight is required',
  },
  lengthRequired: {
    id: 'product.validation.lengthRequired',
    description: 'Length required validation message',
    defaultMessage: 'Length is required',
  },
  widthRequired: {
    id: 'product.validation.widthRequired',
    description: 'Width required validation message',
    defaultMessage: 'Width is required',
  },
  heightRequired: {
    id: 'product.validation.heightRequired',
    description: 'Height required validation message',
    defaultMessage: 'Height is required',
  },
  diameterRequired: {
    id: 'product.validation.diameterRequired',
    description: 'Diameter required validation message',
    defaultMessage: 'Diameter is required',
  },
  volumeRequired: {
    id: 'product.validation.volumeRequired',
    description: 'Volume required validation message',
    defaultMessage: 'Volume is required',
  },
  densityRequired: {
    id: 'product.validation.densityRequired',
    description: 'Density required validation message',
    defaultMessage: 'Density is required',
  },
  clearTemperatureSettings: {
    id: 'product.temperature.clearTemperatureSettings',
    description: 'Clear Temperature Settings button text',
    defaultMessage: 'Clear',
  },
  temperatureControlled: {
    id: 'product.temperature.temperatureControlled',
    description: 'Temperature Controlled toggle label',
    defaultMessage: 'Temperature Controlled',
  },
})
